export function truncateUrl(url: string, maxLen = 35): string {
    try {
        const parsed = new URL(url)
        const display = parsed.host + parsed.pathname
        return display.length > maxLen
            ? display.slice(0, maxLen) + '...'
            : display
    } catch {
        return url.length > maxLen ? url.slice(0, maxLen) + '...' : url
    }
}

/**
 * Build the public apply URL for a screening job from its urlId.
 * Mirrors the logic in KitScreeningJobsTab.tsx.
 */
export function buildApplyUrl(urlId: string): string {
    const trimmed = urlId.trim()
    if (!trimmed) return ''

    if (typeof window === 'undefined') {
        return `https://jobseeker.contxt.network/apply/${encodeURIComponent(trimmed)}`
    }

    const hostname = window.location.hostname
    const isLocal =
        hostname === 'localhost' ||
        hostname === '127.0.0.1' ||
        hostname === '0.0.0.0'

    if (isLocal) {
        const origin = window.location.origin.replace(/\/+$/, '')
        return `${origin}/jobseeker/apply/${encodeURIComponent(trimmed)}`
    }

    return `https://jobseeker.contxt.network/apply/${encodeURIComponent(trimmed)}`
}
